import clsx from "clsx";
import parseMinutes from "~/helpers/parseMinutes";

/**
 * Displays minutes in a 5h 20m format
 */
const FormattedMinutes = ({ minutes }: { minutes: number }) => {
  const parsedWaitTimes = parseMinutes(minutes);

  return (
    <>
      {/* Hours */}
      {parsedWaitTimes.hours ? <span>{parsedWaitTimes.hours}h </span> : false}
      {/* Minutes */}
      {parsedWaitTimes.minutes ? (
        <span>{parsedWaitTimes.minutes}m</span>
      ) : (
        false
      )}
    </>
  );
};

export default FormattedMinutes;
